import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HighLightedColor } from '@shared/components/header/quick-access/components/quick-access-entry/quick-access-entry.component';
import {
  ChargingStationState,
  QuickSearchResult,
  SearchCategoryEnum,
  SearchResult,
} from '../../data/quick-access.model';

@Component({
  selector: 'eop-quick-access-results',
  templateUrl: './quick-access-results.component.html',
  styleUrls: ['./quick-access-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QuickAccessResultsComponent {
  private readonly translate = inject(TranslateService);

  readonly HighLightedColor = HighLightedColor;
  readonly ChargingStationState = ChargingStationState;
  readonly MAX_RESULTS = 10;

  @Input() compact: boolean = false;
  @Input() searchInProgress: boolean = false;

  @Output() resultClicked = new EventEmitter<SearchResult>();
  @Output() selectedResultChange = new EventEmitter<SearchResult>();

  chargePointsResults: SearchResult[] = [];
  chargingStationsResults: SearchResult[] = [];
  resultsLabel: string;
  resultListEmpty: boolean;

  protected searchResults: QuickSearchResult;
  private currentlySelectedResult: SearchResult;

  get selectedResult() {
    return this.currentlySelectedResult;
  }

  @Input()
  set results(value: QuickSearchResult) {
    this.searchResults = value;
    this.resultListEmpty = value?.searchResults.length === 0;
    this.resultsLabel = this.getResultsLabel();
    this.chargePointsResults = value?.searchResults.filter(
      elm => elm.category === SearchCategoryEnum.CHARGEPOINT
    );
    this.chargingStationsResults = value?.searchResults.filter(
      elm => elm.category === SearchCategoryEnum.CHARGINGSTATION
    );
  }

  @Input()
  set selectedResult(result: SearchResult) {
    this.currentlySelectedResult = result;
    this.selectedResultChange.emit(this.currentlySelectedResult);
  }

  onResultClicked(element: SearchResult): void {
    this.resultClicked.emit(element);
  }

  private getResultsLabel(): string {
    const total =
      this.searchResults?.chargepointResults + this.searchResults?.chargingStationResults;
    let labelResult =
      this.searchResults?.searchResults.length + ' ' + this.translate.instant('GLOBAL.RESULTS');
    if (total > this.MAX_RESULTS) {
      labelResult = this.translate.instant('GLOBAL.MORE_RESULTS_THAN', { total: this.MAX_RESULTS });
    }

    return labelResult;
  }
}
